import axios from 'axios'
import qs from 'qs'

export default {
  data() {
    return {
      isDownload: false
    }
  },
  methods: {
    downloadExcel() {
      const href = this.exportUrl + (this.exportUrl.indexOf('?') > -1 ? '&' : '?') + qs.stringify(this.searchForm)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = href
      a.click()
    },
    /**
     * 文件下载
     * @param config = {url: '资源地址，字符串，必填，绝对路径', searchForm: '请求参数，对象，非必填', filename: '文件名，字符串，非必填，需要有后缀，如xxx.zip'}
     */
    async downloadFile(config) {
      const {url, searchForm} = config
      const filename = config.filename || (url.split('/').pop())
      this.isDownload = true

      return new Promise(resolve => {
        axios({
          method: 'GET',
          url: url,
          params: {
            ...searchForm
          },
          responseType: 'blob',
          headers: {'Content-Type': 'application/json; application/octet-stream'},
          timeout: 180000
        }).then(res => {
          resolve()
          if (res.status === 200) {
            // 构造一个blob对象来处理数据，并设置文件类型
            const blob = new Blob([res.data])
            if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
              navigator.msSaveBlob(blob, filename)
            } else {
              const href = URL.createObjectURL(blob) // 创建新的URL表示指定的blob对象
              const a = document.createElement('a') // 创建a标签
              a.style.display = 'none'
              a.href = href // 指定下载链接
              a.download = filename // 指定下载文件名
              a.click() //触发下载
              URL.revokeObjectURL(a.href) // 释放URL对象
            }
          } else {
            this.$message.error('下载出错，请联系管理员')
          }
          this.isDownload = false
        }).catch(err => {
          resolve()
          this.isDownload = false
        })
      })
    }
  }
}
